"use client";

import { useState } from "react";
import Image from "next/image";

import { env } from "~/env.mjs";
import { PLACEHOLDER_IMAGE } from "~/lib/config/content";

interface CategoryImageProps {
  categoryId: number;
  productName: string;
  loading: "eager" | "lazy";
}

export function CategoryImage({
  categoryId,
  productName,
  loading,
}: CategoryImageProps) {
  const [imgSrc, setImgSrc] = useState(
    `${env.NEXT_PUBLIC_ASSETS_URL}/images/storefront/categories/${categoryId}.jpg`,
  );

  return (
    <Image
      loading={loading}
      decoding="sync"
      src={imgSrc}
      alt={`A small picture of ${productName}`}
      className="hover:bg-accent2 mb-2 h-14 w-14 border border-yellow-400 bg-gray-200"
      width={48}
      height={48}
      quality={65}
      onError={() => {
        setImgSrc(PLACEHOLDER_IMAGE);
      }}
    />
  );
}
